var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stateBar",class:{ native: _vm.isNative },style:({ backgroundColor: _vm.bgcolor })})
}
var staticRenderFns = []

export { render, staticRenderFns }